export enum FacilityLevelEnum {
  Building,
  Floor,
  Area,
}
